import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import SidebarSection from './section/SidebarSection';
import AppConfig from '../consts/AppConfig';
import LogoIcon from '../assets/images/logo-icon.png';
import LogoFull from '../assets/images/logo-full.png';

function Sidebar({ disableNavigation = false, allowedRoutes = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);

  useEffect(() => {
    // Get user role from session data in localStorage
    const sessionData = localStorage.getItem('sessionData');
    if (sessionData) {
      try {
        const session = JSON.parse(sessionData);
        const role = session?.companies?.find(company =>
          company?.id == session?.currentCompany
        )?.role?.name;

        setUserRole(role);
        setIsPlatformAdmin(Boolean(session?.user?.isPlatformAdmin));
      } catch (error) {

      }
    }
  }, []);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  // Function to check if user has admin access
  const hasAdminAccess = () => {
    return userRole === 'COMPANY_OWNER' || userRole === 'ADMIN';
  };

  // Function to get items for a section, filtering out admin-only routes for non-admin users
  const getSectionItems = (routes) => {
    return routes
      .map(routeId => AppConfig.GetRouteById(routeId))
      .filter(route => {
        // Filter out admin-only routes for non-admin users
        if (route && route.adminOnly && !hasAdminAccess()) {
          return false;
        }
        // Rotas só do dono (a página bloqueia os demais com "Acesso restrito")
        if (route && route.ownerOnly && userRole !== 'COMPANY_OWNER') {
          return false;
        }
        // Filter out platform-admin-only routes for non platform admin users
        if (route && route.platformAdminOnly && !isPlatformAdmin) {
          return false;
        }
        return Boolean(route);
      });
  };

  // Filter out sections that have no visible items after admin filtering
  const visibleSections = AppConfig.MenuRoutes.filter(section => {
    const items = getSectionItems(section.routes);
    return items.length > 0;
  });

  return (
    <div
      id="sidebar"
      className={isOpen ? "sidebar-opened sidebar-expanded" : "sidebar-opened"}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="logo-container">
        <img src={LogoIcon} className={`logo logo-icon ${isOpen ? 'hidden' : 'visible'}`} alt="Logo Icon"/>
        <img src={LogoFull} className={`logo logo-full ${isOpen ? 'visible' : 'hidden'}`} alt="Logo Full"/>
      </div>
      <div className="sidebar-groups">
        {visibleSections.map((section, index) => (
          <SidebarSection
            key={section.label || index}
            title={section.label}
            icon={section.icon}
            items={getSectionItems(section.routes)}
            isOpen={isOpen}
            disableNavigation={disableNavigation}
            allowedRoutes={allowedRoutes}
          />
        ))}
      </div>
    </div>
  );
}

export default Sidebar;
